module.exports = "/images/list-and-sell.png?0843d8b448537782f459f91ab89d2aa2";